import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'

i18n.use(LanguageDetector).use(reactI18nextModule).init({
  resources: {
    en: {
      translations: require('./locales/en.json')
    },
    my: {
      translations: require('./locales/my.json'),
    },
    de: {
      translations: require('./locales/de.json'),
    },
    cn: {
      translations: require('./locales/cn.json'),
    },
    hi: {
      translations: require('./locales/hi.json'),
    },
  },
  fallbackLng: 'en',
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: ':',
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  react: {
    wait: true
  },
})

export default i18n
